import AsyncSelect from '@/components/form-elements/AsyncSelect/AsyncSelect.vue';
import Datepicker from '@/components/form-elements/Datepicker/Datepicker.vue';
import RadioNumberButton from '@/components/form-elements/RadioNumberButton/RadioNumberButton.vue';
import YesNoSwitch from '@/components/form-elements/YesNoSwitch/YesNoSwitch.vue';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import type { FormConfig } from '@/utils/form';
import { propertyBeitragsReduzierungSection } from '@/features/Sparten/shared/formConfigs/property/input/beitragsReduzierungSection';

export const absicherungsSection: FormConfig = {
  formName: 'PfeAbsicherung',
  fieldConfigs: [
    {
      component: Datepicker,
      path: 'versicherungsbeginn',
      label: 'Versicherungsbeginn',
    },
    {
      component: AsyncSelect,
      path: 'deckungssumme',
      label: 'Deckungssumme',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.DECKUNGSSUMME,
      },
    },
    {
      component: AsyncSelect,
      path: 'selbstbeteiligung',
      label: 'Gewünschte Selbstbeteiligung',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.SELBSTBETEILIGUNG,
      },
    },
    {
      component: AsyncSelect,
      path: 'laufzeit',
      label: 'Laufzeit',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.LAUFZEIT,
      },
    },
    {
      component: AsyncSelect,
      path: 'zahlweise',
      label: 'Zahlweise',
      inputAttrs: {
        'choices-list': SIMPLE_CHOICE.PAYMENT_PERIOD,
      },
    },
    {
      component: RadioNumberButton,
      path: 'pferdeAnzahl',
      label: 'Anzahl Pferde',
    },
  ],
};

export const beitragsReduzierungSection: FormConfig = {
  formName: 'PfeBeitragsReduzierung',
  fieldConfigs: [
    ...propertyBeitragsReduzierungSection.fieldConfigs,
    {
      component: YesNoSwitch,
      path: 'reitverein',
      label: 'Mitglied im Reitverein?',
    },
  ],
};
